import React, { Component, useEffect } from 'react'
import "../css/admin/AdminUsuarios.css";
import equis from "../assets/eliminar.svg"
import check from "../assets/check.svg";
import axios from "axios";
import SideBar from './adminComponents/SideBar';
import Modal from './components/Modal';
import ModalAdminEliminar from './adminComponents/ModalAdminEliminar';
import ModalUserForm from './adminComponents/ModalUserForm';
import HeaderAdmin from './adminComponents/HeaderAdmin';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import NavBarInfo from './adminComponents/NavBarInfo';
import { ComponenteSpinner } from './adminComponents/ComponenteSpinner';
import jwt from 'jwt-decode'
/*import MaterialTable, { MaterialTableProps } from 'material-table';*/
import MaterialTable, { Column } from "@material-table/core";


export class AdminUsuarios extends Component {

    constructor(props){
        super(props);
        
        this.state={
            modalIsOpen:false,
            modalEliminar:false,
            modalVer:false,
            usuarios:[],
            datosUsuario:{
                nombres:"",
                apellidos:"",
                identificacion:"",
                rol:""
            },
            columnas:[
                {
                    title:"#",
                    field:"idsccecuentausuario",
                },
                {
                    title:"Nombres",
                    field:"idsccepersonaNavigation.nombres",
                },
                {
                    title:"Apellidos",
                    field:"idsccepersonaNavigation.apellidos",
                    
                },
                {
                    title:"Usuarios",
                    field:"username",
                    
                },
                {
                    title:"Correo",
                    field:"idsccepersonaNavigation.correoalterno",
                    
                }
            ],
            acciones:[
                rowData=> ({
                    icon:'edit',
                    iconProps: { style: {color: "#767E9F" } },
                    onClick: (event, rowData) => this.abrirModalEditarPersona(rowData)
                }),
                rowData=> ({
                    icon:'delete',
                    iconProps: { style: {color: "#767E9F" } },
                    onClick: (event, rowData) => this.abrirModalEliminarPersona(rowData)

                })
            
            ],
            editarUsuario:{
                id:0,
                nombres:"",
                apellidos:"",
                usuario:"",
                telefono:"",
                correoAlterno:"",
                rol:"",
                unidad:"",
                alias:"",
                estado:1
            },
            modal:{
                show:false,
                titulo:"",
                mensaje:"",
                imagen:""
            },
            cerrarSesion:false,
            loading:true,
            noadmin:false,
        };

        this.abrirModalEditarPersona=this.abrirModalEditarPersona.bind(this);
        this.cerrarModalEditarPersona=this.cerrarModalEditarPersona.bind(this);
        this.handlerEditarPersona=this.handlerEditarPersona.bind(this);
        this.abrirModalEliminarPersona=this.abrirModalEliminarPersona.bind(this);
        this.cerrarModalEliminarPersona=this.cerrarModalEliminarPersona.bind(this);
        this.abrirModal=this.abrirModal.bind(this);
        this.cerrarModal=this.cerrarModal.bind(this);
    }

    abrirModal(){
        this.setState({
            modal:{
                ...this.state.modal,
                show:true
            }
        });
    }

    cerrarModal(){
        this.setState({
            modal:{
                titulo:"",
                mensaje:"",
                imagen:"",
                show:false
            }
        });
        //console.log("cerrar modal "+this.state.modal);
    }

    abrirModalEditarPersona(rowData){
        this.traerDatosPersona(rowData);
        this.setState({modalIsOpen:true});
    }

    cerrarModalEditarPersona(){
        this.setState({modalIsOpen:false});
       // console.log("cerrar modal "+this.state.modalIsOpen);
    }

    abrirModalEliminarPersona(rowData){
        this.setState({modalEliminar:true});
        this.traerDatosEliminarPersona(rowData);
    }

    cerrarModalEliminarPersona(){
        this.setState({modalEliminar:false});
       // console.log("cerrar modal eliminar"+this.state.modalEliminar);
    }

    traerDatosPersona = async (rowData) => {
     
        await this.setState({
            editarUsuario:{
                ...this.state.editarUsuario,
                id:rowData.idsccepersonaNavigation.idsccepersona,
                nombres: rowData.idsccepersonaNavigation.nombres,
                apellidos: rowData.idsccepersonaNavigation.apellidos,
                telefono: rowData.idsccepersonaNavigation.telefono,
                usuario:rowData.username,
                correoAlterno: rowData.idsccepersonaNavigation.correoalterno,
                rol: rowData.idsccepersonaNavigation.rol,
                unidad: rowData.idsccepersonaNavigation.unidad,
                alias: rowData.alias,
                identificacion: rowData.idsccepersonaNavigation.identificacion,
            }
        })
        //console.log("traer datos");
        //console.log(this.state.editarUsuario);
    }
    
    handlerEditarPersona=async(e)=>{
        //e.persist();
        await this.setState({
            editarUsuario:{
                ...this.state.editarUsuario,
                [e.target.name]:e.target.value
            }
        })
        //console.log(this.state.editarUsuario);
    }

    postEditarPersona=async(e)=>{
        e.preventDefault()

        var editarPersona= {
            ...this.state.editarUsuario,
            //identificacion:this.state.datosUsuario.identificacion
        }

        /*console.log("editar persona");
        console.log(editarPersona);*/
        await axios.put(`${process.env.REACT_APP_API}api/Persona/${editarPersona.id}`,editarPersona)
        .then(resp=>{
            if(resp.status===200){
                this.getUsuarios();
                this.cerrarModalEditarPersona();
                this.setState({
                    modal:{
                        show:true,
                        titulo:"Usuario modificado",
                        mensaje:"Usuario editado con éxito.",
                        imagen:check
                    }
                })
            }
        }).catch(error=>{
            this.setState({
                modal: {
                    show: true,
                    titulo: "Error al guardar la solicitud",
                    mensaje: "Existe un problema al guardara la solicitud. Por favor, intentarlo mas tarde.",
                    imagen: equis,
                }
            });

        })
    }

    traerDatosEliminarPersona=async(rowData)=>{
        await this.setState({
            editarUsuario:{
                id: rowData.idsccecuentausuario,
                nombres: rowData.idsccepersonaNavigation.nombres,
                apellidos: rowData.idsccepersonaNavigation.apellidos,
                telefono: rowData.idsccepersonaNavigation.telefono,
                usuario:rowData.username,
                correoAlterno: rowData.idsccepersonaNavigation.correoalterno,
                rol: rowData.idsccepersonaNavigation.rol,
                unidad: rowData.idsccepersonaNavigation.unidad,
                alias:rowData.alias,
                estado:0
            }
        })
        //console.log("traer datos eliminar persona");
        //console.log(this.state.editarUsuario);
    }

    postEliminarPersona=async(e)=>{
        e.preventDefault()
        
        var eliminarPersona = {
            username:this.state.editarUsuario.usuario,
            alias:this.state.editarUsuario.alias,
            isActive:false,
        }
        var id=this.state.editarUsuario.id;
       
        await axios.put(`${process.env.REACT_APP_API}api/CuentaUsuario/${id}`,eliminarPersona)
        .then(resp=>{
            if(resp.status===200){
                this.getUsuarios();
                this.cerrarModalEliminarPersona();
                this.setState({
                    modal:{
                        show:true,
                        titulo:"Usuario eliminado",
                        mensaje:"Usuario eliminado con éxito.",
                        imagen:check
                    }
                })
            }
        }).catch(error=>{
           // console.log(error.message);
        })
    }

    getUsuarios=async()=>{
        
        await axios.get(`${process.env.REACT_APP_API}api/CuentaUsuario`)
        .then(response=>{
            this.setState({
                usuarios: response.data,
                loading: false
            });
        }).catch(error=>{
            //console.log(error.message);
        })
        //console.log(this.state.usuarios);
    }

   
    cerrarSesion=async()=>{
        this.props.setValue(false);
        Cookies.remove("nombres");
        Cookies.remove("apellidos");
        Cookies.remove("identificacion");
        Cookies.remove("token");
        Cookies.remove("cas");

        Cookies.remove("rol");
        Cookies.remove("username");
        Cookies.remove("DatosPersonalesGIA.CAS");
        Cookies.remove("id");
        Cookies.remove("correoAlterno");
        Cookies.remove("Nombre");
      
      window.location.href = "/logout"
      this.setState({ cerrarSesion: true });
        //console.log("cerrando sesion");
    }

    componentDidMount() {
        console.log("didmount token: "+ token);
        var token = Cookies.get("token");
        var tokendecode = jwt(token);
        this.state.datosUsuario.nombres = tokendecode["Nombres"];
        this.state.datosUsuario.apellidos = tokendecode["Apellidos"];
        this.state.datosUsuario.rol = tokendecode["Rol"];
       
        if(this.state.datosUsuario.rol !== "Admin" ){
            //alert("Usted no tiene un rol administrativo.")
            this.setState({
                noadmin:true
            })
           //window.location.href = "/inicio"
        }
        this.setState({
            datosUsuario:{
                nombres: tokendecode["Nombres"],
                apellidos: tokendecode["Apellidos"],
                
            }
        });
        this.setearHeader();
        //this.fechaActual();
        this.getUsuarios();
    }

    setearHeader(){
        //console.log("setear header");
        var token = Cookies.get("token")
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            axios.defaults.headers.common['Authorization'] = null;
            
        }
    }

    render() {
        var nombresCompletos=`${this.state.datosUsuario.nombres} ${this.state.datosUsuario.apellidos}`
        //var identificacion=this.state.datosUsuario.identificacion;
        return (
           this.state.noadmin? 
           <Modal isOpen={this.state.noadmin} cerrarModal={this.cerrarModal} verBoton={false} >
                <p className='text-center'><strong>Error en la validación del ROL</strong></p>
                <div  className='mt-3 mb-3 text-center'>
                    <p  className='text-center'>Estimad@ {this.state.datosUsuario.nombres} {this.state.datosUsuario.apellidos}, usted no tiene un rol administrativo. </p>
                    <button
                        type="button"
                        onClick={() => window.location.href = "/inicio"}
                        className="modal-error-admin"
                    >Inicio
                    </button>
                     <button
                        type="button"
                        onClick={() => window.location.href = "/logout"}
                        className="modal-error-admin"
                    >Cerrar sesión
                    </button>
                </div>          
            </Modal>
            :
           
            this.state.cerrarSesion? <Navigate to="/inicio" />:
            this.state.loading ? 
                <ComponenteSpinner></ComponenteSpinner>:
            (<div id="admin-fondo">
                <HeaderAdmin nombresCompletos={nombresCompletos}></HeaderAdmin>
                <NavBarInfo cerrarSesion={this.cerrarSesion}></NavBarInfo>
                
                <div className='row adminUsers-body'>
                <SideBar nombres={nombresCompletos} tipo={"usuarios"}></SideBar>
                    <div className='col-md-9 mt-4'>
                        <p className='admin-titulo'>Usuario</p>
                        <MaterialTable
                        title=""
                        columns={this.state.columnas}
                        data={this.state.usuarios}
                        actions={this.state.acciones}
                        options={{
                            pageSize: 5,
                            pageSizeOptions: [5, 10, 15, 20, 50],
                            actionsColumnIndex:-1,
                            headerStyle:{backgroundColor: '#767E9F',color: 'white', fontWeight:'bold', zIndex:0}
                        }}
                        localization={{
                            header:{actions:"Acciones"}, 
                            toolbar: {searchPlaceholder: 'Filtrar'},
                            pagination:{labelRowsSelect:"Filas"},
                        }}
                        ></MaterialTable>
                        
                        
                    </div>
                </div>
                
                {this.state.modalIsOpen&&
                <ModalUserForm isOpen={this.state.modalIsOpen} cerrarModal={this.cerrarModalEditarPersona} 
                tituloHeader="EDITAR USUARIO" submit={this.postEditarPersona} txtBtnSubmit={"EDITAR"} txtBtnCancel={"CANCELAR"}>
                    
                    <form>
                        <div className="row mt-3">
                            <label className='col-sm-3 col-form-label' htmlFor='nombres' id="modalForm-texto">Nombres: </label>
                            <div className="col-sm-8">
                                <input className="form-control" type="text" name="nombres" value={this.state.editarUsuario.nombres} onChange={this.handlerEditarPersona}></input>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <label className='col-sm-3 col-form-label' htmlFor="apellidos" id="modalForm-texto">Apellidos: </label>
                            <div className="col-sm-8">
                                <input className="form-control" type="text" name="apellidos" value={this.state.editarUsuario.apellidos} onChange={this.handlerEditarPersona}></input>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <label className='col-sm-3 col-form-label' htmlFor="telefono" id="modalForm-texto">Telefono: </label>
                            <div className="col-sm-8">
                                <input className="form-control" type="text" name="telefono" value={this.state.editarUsuario.telefono} onChange={this.handlerEditarPersona}></input>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <label className='col-sm-3 col-form-label' htmlFor="correoAlterno" id="modalForm-texto">Correo alterno: </label>
                            <div className="col-sm-8">
                                <input className="form-control" type="text" name="correoAlterno" value={this.state.editarUsuario.correoAlterno} onChange={this.handlerEditarPersona}></input>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <label className='col-sm-3 col-form-label' htmlFor="usuario" id="modalForm-texto">Usuario: </label>
                            <div className="col-sm-8">
                                <input className="form-control" type="text" name="usuario" value={this.state.editarUsuario.usuario} onChange={this.handlerEditarPersona} disabled></input>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <label className='col-sm-3 col-form-label' htmlFor="alias" id="modalForm-texto">Alias: </label>
                            <div className="col-sm-8">
                                <input className="form-control" type="text" name="alias" value={this.state.editarUsuario.alias} onChange={this.handlerEditarPersona} disabled></input>
                            </div>
                        </div>

                    </form>
                </ModalUserForm>}

                {this.state.modalEliminar&&
                    <ModalAdminEliminar 
                    isOpen={this.state.modalEliminar} 
                    cerrarModal={this.cerrarModalEliminarPersona} 
                    txtBtnSubmit="ACEPTAR" 
                    txtBtnCancel="CANCELAR"
                    submit={this.postEliminarPersona}>
                        <h4 className='text-center'><strong>Desactivar cuenta</strong></h4>
                        <div className='mt-6 mb-6'>
                            <img className="admin-check" src={equis} alt="Eliminar"></img>
                        </div>
                        
                        <p className='text-center'><strong>¿Está seguro que desea desactivar esta cuenta?</strong></p>
                        <p className='text-center'>Esta acción no podrá deshacerse</p>
                
                    </ModalAdminEliminar>
                }

                {this.state.modal.show&& 
                    <Modal isOpen={this.state.modal.show} cerrarModal={this.cerrarModal} verBoton={true} textoBoton="ACEPTAR" >
                        <p className='text-center'><strong>{this.state.modal.titulo}</strong></p>
                        <div  className='mt-3 mb-3 text-center'>
                            <img className="registroContra-check" src={this.state.modal.imagen} alt="Error"></img>
                        </div>

                        <p className='text-center'>{this.state.modal.mensaje}</p>
                        
                    </Modal>
                }
              

                
            </div>
           )
        )
    }
    
}

export default AdminUsuarios
